<template>
  <component v-if="layout" :is="layout === TABS ? 'NewEnquiryTabbed' : 'NewEnquiryClassic'" v-bind="$props" />
</template>

<script>
import NewEnquiryClassic from './NewEnquiryClassic.vue'
import NewEnquiryTabbed from './NewEnquiryTabbed.vue'
import { resolveLayout, TABS } from './enquiryLayout'

// The New Enquiry route: one page or tabs, as the admin setting says (or ?view= from the review menu).
export default {
  name: 'NewEnquiryEntry',
  components: { NewEnquiryClassic, NewEnquiryTabbed },
  props: {
    customerId0: { type: Number, default: null },
    custName0: { type: String, default: '' },
    sharedEnqId0: { type: Number, default: null }
  },
  data() {
    return { layout: null, TABS }
  },
  async created() {
    this.layout = await resolveLayout(this.$route && this.$route.query)
  }
}
</script>
